import Grid from '@mui/material/Grid2';
import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box } from '@mui/material';
import { settingsAtom } from '../../atoms/Settings';
import { BannerContainer } from '../Banner/BannerContainer';
import { getDailyProductsBanner } from '../../api/DailyProducts';
import { ProductsCarousel } from '../ProductsCarousel/ProductsCarousel';

export const DailyProducts = () => {
  const settings = useRecoilValue(settingsAtom);

  const [bannerUrl, setBannerUrl] = useState('');

  useEffect(() => {
    getDailyProductsBanner()
      .then((url) => setBannerUrl(url))
      .catch((err) => toast.error(err.message));
  }, []);

  return (
    <Grid container spacing={1.5} width='100%'>
      {!!bannerUrl && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <BannerContainer
            maxHeight={800}
            banner={{
              id: 0,
              title: settings.settingsV1.todays_product,
              sortOrder: 0,
              isActive: true,
              linkUrl: '',
              image: bannerUrl,
              description: '',
              createdAt: new Date(),
              updatedAt: new Date(),
            }}
          />
        </Grid>
      )}

      <Grid size={{ xs: 12, sm: 6 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
          }}
        >
          <ProductsCarousel
            title={settings.settingsV1.todays_product}
            popularity='daily'
          />
        </Box>
      </Grid>
    </Grid>
  );
};
